import { http } from "../httpHandler";
import {
  CreateDeliverableTemplatePayload,
  DeliverableTemplate,
  GetTableListParams,
  TServerErrorResponse,
  UpdateDeliverableTemplatePayload,
} from "@/types";
import { links } from "@/constants";

export const DELIVERABLE_TEMPLATE_LIST = "DELIVERABLE_TEMPLATE_LIST";
export const DELIVERABLE_TEMPLATE_GET = "DELIVERABLE_TEMPLATE_GET";

/**
 * `GET /deliverable-template` — the templates the acting user owns, plus the
 * ones shared with them and the firm-wide ones. A template is a saved prompt
 * and nothing else.
 */
export const getDeliverableTemplates = async (
  params?: Partial<GetTableListParams>,
): Promise<DeliverableTemplate[]> => {
  try {
    const response = await http.get<DeliverableTemplate[]>(
      links.deliverableTemplate.index,
      { params },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/** `POST /deliverable-template` — `{ name, description?, promptText }`. */
export const createDeliverableTemplate = async (
  data: CreateDeliverableTemplatePayload,
): Promise<DeliverableTemplate> => {
  try {
    const response = await http.post<DeliverableTemplate>(
      links.deliverableTemplate.index,
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/** `GET /deliverable-template/:id`. */
export const getDeliverableTemplateById = async (
  id: string,
): Promise<DeliverableTemplate> => {
  try {
    const response = await http.get<DeliverableTemplate>(
      links.deliverableTemplate.byId(id),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * `PATCH /deliverable-template/:id` — editing a shared template changes it for
 * everyone immediately; already-generated deliverables are untouched.
 */
export const updateDeliverableTemplate = async (
  id: string,
  data: UpdateDeliverableTemplatePayload,
): Promise<DeliverableTemplate> => {
  try {
    const response = await http.patch<DeliverableTemplate>(
      links.deliverableTemplate.byId(id),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/** `DELETE /deliverable-template/:id`. */
export const deleteDeliverableTemplate = async (id: string): Promise<void> => {
  try {
    await http.delete(links.deliverableTemplate.byId(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
